webpackJsonp([271323403255855],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AnimationReel = function AnimationReel() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "row width-container center-image" },
	      _react2.default.createElement(
	        "div",
	        { className: "embed-responsive video embed-responsive-16by9" },
	        _react2.default.createElement("iframe", { className: "embed-responsive-item", src: "https://www.youtube.com/embed/tIgV42gfT-A", allowFullScreen: true })
	      )
	    )
	  );
	};
	
	exports.default = AnimationReel;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-animation-animation-reel-js-3cc6e217e9826b0d03ad.js